import script from "./post.vue?vue&type=script&setup=true&lang=js"
export * from "./post.vue?vue&type=script&setup=true&lang=js"

import "./post.vue?vue&type=style&index=0&id=33850361&scoped=true&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33850361"]])

export default __exports__